<template>
  <layout>
    <page-header :actions="actions" :header="$t('import_entities.title')" />
    <div class="content">
      <admin-table ref="table" v-bind="tableProps" @api-result="updateExportUrl">
        <template slot="status" slot-scope="{ item }">
          <span :class="getStatusClass(item.status)">
            {{ $t(`import_entities.status_${item.status}`) }}
          </span>
        </template>
        <template slot="logs" slot-scope="{ item }">
          <button
            v-if="item.logs && item.logs.length"
            class="btn btn-sm btn-info"
            @click="showLogs(item)"
          >
            {{ item.logs.length }} logs
          </button>
          <span v-else>-</span>
        </template>
      </admin-table>
    </div>

    <!-- Logs Modal -->
    <div v-if="selectedItem" class="modal fade show" style="display: block;" @click="selectedItem = null">
      <div class="modal-dialog modal-lg" @click.stop>
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Import Logs - {{ selectedItem.filename }}</h5>
            <button type="button" class="close" @click="selectedItem = null">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body" style="max-height: 400px; overflow-y: auto;">
            <div
              v-for="log in selectedItem.logs"
              :key="log.id"
              :class="'log-entry log-' + log.level"
            >
              <small>{{ formatDate(log.created_at) }}</small>
              <span>{{ log.message }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import moment from 'moment'
import Api from './Api'

const resourceBase = 'import_entities'

export default {
  name: 'ImportEntitiesIndex',
  components: {
    AdminTable
  },
  data() {
    return {
      selectedItem: null,
      // Table resource configuration
      tableProps: {
        base: resourceBase,
        apiBuilder: () => {
          return new Api({
            include: 'logs',
          })
        },
        sortBy: 'created_at',
        sortDesc: true,
        columns: [
          {
            key: 'id',
            label: this.$t('general.id'),
            sortable: true,
          },
          {
            key: 'filename',
            label: this.$t('import_entities.filename'),
            sortable: true,
          },
          {
            key: 'description',
            label: this.$t('import_entities.description'),
          },
          {
            key: 'status',
            label: this.$t('import_entities.status'),
            // component: 'status',
          },
          {
            key: 'created_at',
            label: this.$t('import_entities.created_at'),
            sortable: true,
            component: 'value-date',
            config: {
              stacked: true,
            },
          },
          {
            key: 'logs',
            label: this.$t('import_entities.logs'),
            // component: 'logs',
          },
        ],

        // define custom row actions
        rowActions: item => {
          let actions = []

          if (this.$allows(`administer`)) {
            actions.push('edit')
          }

          if (item.status === 'pending' || item.status === 'failed') {
            actions.push({
              label: this.$t('import_entities.import'),
              variant: 'success',
              handler: () => this.startImport(item),
            })
          }
          if (this.$allows(`administer`)) {
            actions.push('delete')
          }

          return actions
        },

        // define custom bulk actions
        bulkActions() {
          return []
        },

        searchFields: [
          {
            component: 'text-field',
            type: 'search',
            attribute: 'query',
            placeholder: this.$t('import_entities.search'),
          },
        ],
        searchData: {
          query: null,
        },
      },
      exportUrl: null,
    }
  },

  computed: {
    // Page header actions
    actions() {
      const actions = []
      if (this.$allows(`users.create`)) {
        actions.push({
          id: 'create',
          text: this.$t('general.add_new'),
          icon: 'icon-plus-circle2',
          onClick: () => {
            this.$router.push({
              name: `${resourceBase}.create`,
            })
          },
        })
      }
      return actions
    },
  },

  methods: {
    api() {
      return new Api()
    },
    updateExportUrl(result) {
      this.exportUrl = result.export_url
    },
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY HH:mm')
    },
    getStatusClass(status) {
      const classes = {
        pending: 'badge badge-warning',
        processing: 'badge badge-info',
        completed: 'badge badge-success',
        failed: 'badge badge-danger',
      }
      return classes[status] || 'badge badge-secondary'
    },
    showLogs(item) {
      this.selectedItem = item
    },
    async startImport(item) {
      if (!confirm(this.$t('import_entities.confirm_import'))) return

      try {
        await this.api().startImport(item.id)
        this.$toast.success('Import started')
        this.$refs.table.refresh()
      } catch (error) {
        /* eslint-disable-next-line no-console */
        console.error('Import start error:', error)
        this.$toast.error('Failed to start import')
      }
    },
  },
}
</script>
